var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-2xs flex"},_vm._l((_vm.value),function(asset){return _c('a',{key:asset.id,attrs:{"href":asset.url,"target":"_blank"}},[_c('asset-thumbnail',{staticClass:"h-8 max-w-3xs -my-sm",attrs:{"asset":asset}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }